export default __webpack_public_path__ + "static/media/403.f956a616.png";